import { render, staticRenderFns } from "./UsersAdministrationTableRow.vue?vue&type=template&id=a528fc52&scoped=true&"
import script from "./UsersAdministrationTableRow.vue?vue&type=script&lang=js&"
export * from "./UsersAdministrationTableRow.vue?vue&type=script&lang=js&"
import style0 from "./UsersAdministrationTableRow.vue?vue&type=style&index=0&id=a528fc52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a528fc52",
  null
  
)

export default component.exports